import { QueryKey, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getOrganizationCloudRenderingPolicies } from "../session-management-api";

type OrganizationCloudRenderingPolicies = Awaited<
  ReturnType<typeof getOrganizationCloudRenderingPolicies>
>;

export function useOrganizationCloudRenderingPolicies<
  TData = OrganizationCloudRenderingPolicies,
>(
  options?: Omit<
    UseQueryOptions<OrganizationCloudRenderingPolicies, Error, TData>,
    "queryKey" | "queryFn"
  >,
) {
  return useQuery<OrganizationCloudRenderingPolicies, Error, TData>({
    queryKey: ["policies"] as QueryKey,
    queryFn: getOrganizationCloudRenderingPolicies,
    ...options,
  });
}
